export default __webpack_public_path__ + "static/media/logo-dark.55f999d1.svg";